module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB1526-0e4fa987a75417bb45c5868536e0d998.png";